import React from 'react';
import { ModuleBridge } from '../components';

export const Users = () => {
    return <ModuleBridge moduleId="admin_users_module" />;
};
